export default __webpack_public_path__ + "static/media/tooltipaccountsetup.41d9899d.svg";